<script setup lang="ts">
import { computed } from 'vue'
import { useConfigStore } from '@/stores/configStore'
import { useViewStore } from '@/stores/viewStore'

defineOptions({
  name: 'ControlBar'
})

const configStore = useConfigStore()
const viewStore = useViewStore()

// Computed pour le prix formaté
const formattedPrice = computed(() => configStore.formattedTotalPrice)

// Computed pour le mode de vue actif (synchro avec viewStore)
const activeViewMode = computed(() => viewStore.currentView)

// Fonction pour changer le mode de vue
function setViewMode(mode: 'exterior' | 'interior') {
  console.log('[ControlBar] Changement de mode:', mode)
  viewStore.setViewWithEmit(mode)
  console.log('[ControlBar] viewStore mis à jour avec le mode:', viewStore.currentView)
}
</script>

<template>
  <div class="control-bar">
    <!-- Boutons de contrôle de vue (à gauche) -->
    <div class="view-controls">
      <button
        :class="['view-btn', { active: activeViewMode === 'interior' }]"
        @click="setViewMode('interior')"
      >
        Intérieur
      </button>
      <button
        :class="['view-btn', { active: activeViewMode === 'exterior' }]"
        @click="setViewMode('exterior')"
      >
        Extérieur
      </button>
    </div>

    <!-- Affichage du prix (à droite) -->
    <div class="price-display">
      Prix : {{ formattedPrice }}
    </div>
  </div>
</template>

<style scoped>
.control-bar {
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  max-width: 875px;
  margin-inline: auto;
  padding-block-end: 0.5rem;;
}

.view-controls {
  display: flex;
  gap: 0.5rem;
}

.view-btn {
  margin: 0;
  padding: 0.5em 2em;
  border: 1px solid currentColor;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: color 0.3s ease;
  color: var(--color-text-secondary);
}

.view-btn:hover {
  color: var(--color-text-primary);
}

.view-btn.active {
  color: var(--color-text-primary);
}

.price-display {
  font-size: 26px;
  font-weight: 700;
  color: var(--color-text-primary);
  text-align: right;
}

/* Responsive */
@media (max-width: 768px) {
  .control-bar {
    padding: 8px 16px;
  }

  .view-controls {
    width: 100%;
    /* justify-content: center; */
  }

  .price-display {
    font-size: 18px;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .control-bar {
    padding: 8px 12px;
  }

  .view-btn {
    padding: 8px 16px;
    font-size: 13px;
  }

  .price-display {
    font-size: 16px;
    padding: 0;
  }
}
</style>